import { useMutation } from '@apollo/client';
import { CityMap } from '../../shared/types';
import { CITRIN_UPDATE_CityMap, UpdateCityMapRequest, UpdateCityMapResponse } from '..';

type UpdateMutationFunction = (request: CityMap) => Promise<CityMap>;
export const useUpdateCityMapMutation = (): { mutation: UpdateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<UpdateCityMapResponse, UpdateCityMapRequest>(CITRIN_UPDATE_CityMap);
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_updateCityMap;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
